import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppSourceService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppSources`);
    }
}